// @ts-expect-error not yet migrated
import reduceReducers from 'ContentEditorUI/utils/reduceReducers';
import baseContentModelReducer, { baseContentModelReducerAsJSObject } from 'ContentEditorUI/redux/reducers/contentModel/baseContentModelReducer';
export const withBaseContentModelAsJSObject = (...otherReducers) => {
  return reduceReducers(baseContentModelReducerAsJSObject, ...otherReducers);
};
const reducedReducers = (...otherReducers) => {
  return reduceReducers(baseContentModelReducer, ...otherReducers);
};
export default reducedReducers;